import styled from 'styled-components';
import { FieldContent } from '@salutejs/plasma-core';
export var Content = /*#__PURE__*/styled(FieldContent).withConfig({
  componentId: "plasma-web-core__sc-1lxmd2p-0"
})(["", ";"], function (_ref) {
  var pos = _ref.pos;
  return pos === 'left' ? 'left: 0; margin-left: var(--margin-x-field-content)' : 'right: 0; margin-right: var(--margin-x-field-content)';
});